import React from 'react'
import cx from 'classnames/bind'
import InputBoxDoneTyping from "react-input-box-done-typing";

const ListinInputFilter = props => {
  return (
    <div className={cx({
      "filter-box": true,
      "filter-box--right" : props.filterXPos === 'right'
    })}>
      <span>
      {props.value &&
      <div style={{color: '#00B5D4', marginBottom: 8}} className="reset-filter"
           onClick={() => props.onFilterChange( props.termSearch , null)}>Ré-initialiser
      </div>
      }
      </span>
      <InputBoxDoneTyping
        className="filter-list-input"
        doneTyping={ value => props.onFilterChange( props.termSearch ,value) }
        placeholder="Tapez pour chercher..."
        defaultValue={props.value}
      />
    </div>
  )
}

export default ListinInputFilter
